const state = () => ({
  header: null,
  isScrolled: false,
  webChatLoaded: false,
  headerSettings: {
    items: []
  },
  showNeedHelp: false,
  showNeedHelpContacts: false,
  needHelpInverted: false,
  sendAuthorizationHeader: false,
  authRedirectParams: '',
  footerWhite: false,
  // eslint-disable-next-line id-length
  windowSize: { x: 0, y: 0, mx: 0, my: 0 },
  cancelToken: null,
  isMobileApp: false,
  isUlHc: false,
  cameFromMastercard: false
});

const getters = {
  header(state) {
    return state.header;
  },
  isScrolled(state) {
    return state.isScrolled;
  },
  webChatLoaded(state) {
    return state.webChatLoaded;
  },
  headerSettings(state) {
    return state.headerSettings;
  },
  showNeedHelp(state) {
    return state.showNeedHelp;
  },
  showNeedHelpTooltip(state) {
    return state.showNeedHelpContacts;
  },
  needHelpInverted(state) {
    return state.needHelpInverted;
  },
  sendAuthorizationHeader(state) {
    return state.sendAuthorizationHeader;
  },
  authRedirectParams(state) {
    return state.authRedirectParams;
  },
  footerWhite(state) {
    return state.footerWhite;
  },
  windowSize(state) {
    return state.windowSize;
  },
  cancelToken(state) {
    return state.cancelToken;
  },
  isMobileApp(state) {
    return state.isMobileApp;
  },
  isUlHc(state) {
    return state.isUlHc;
  },
  cameFromMastercard(state) {
    return state.cameFromMastercard;
  }
};

const mutations = {
  setHeader(state, payload) {
    state.header = payload;
  },
  setIsScrolled(state, payload) {
    state.isScrolled = payload;
  },
  setWebChatLoaded(state, payload) {
    state.webChatLoaded = payload;
  },
  setHeaderSettings(state, payload) {
    state.headerSettings = payload;
  },
  setShowNeedHelp(state, payload) {
    if (!payload) {
      state.showNeedHelpContacts = false;
    }

    state.showNeedHelp = payload;
  },
  setShowNeedHelpContacts(state, payload) {
    state.showNeedHelpContacts = payload;
  },
  setNeedHelpInverted(state, payload) {
    state.needHelpInverted = payload;
  },
  setSendAuthorizationHeader(state, payload) {
    state.sendAuthorizationHeader = payload;
  },
  setAuthRedirectParams(state, payload) {
    state.authRedirectParams = payload;
  },
  setFooterWhite(state, payload) {
    state.footerWhite = payload;
  },
  setWindowSize(state, payload) {
    state.windowSize = payload;
  },
  setCancelToken(state, payload) {
    state.cancelToken = payload;
  },
  setIsMobileApp(state, payload) {
    state.isMobileApp = payload;
  },
  setIsUlHc(state, payload) {
    state.isUlHc = payload;
  },
  cameFromMastercard(state, payload) {
    state.cameFromMastercard = !!payload;
  }
};

const actions = {
  setHeader({ commit }, payload) {
    commit('setHeader', payload);
  },
  setIsScrolled({ commit }, payload) {
    commit('setIsScrolled', payload);
  },
  setAuthRedirectParams({ commit }, payload) {
    commit('setAuthRedirectParams', payload);
  }
};

export const general = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
